<template>
  <div class="planner-page">
    <div @click="hideDropdown" class="page-header">
      <h4>Bookings Board</h4>
      <ol class="breadcrumbs">
        <li class="breadcrumb-item">
          <router-link to="/">Home</router-link>
        </li>
        <li class="breadcrumb-item active">View Boards</li>
        <li class="breadcrumb-item active">Bookings Board</li>
      </ol>
    </div>
    <tabs :options="{useUrlFragment: false }">
        <div class="header no-gutter">
          <div @click="hideDropdown" class="d-flex planer-date-period">
            <tab name="All" id="planner-all" :class-name="'tab-content-table'">
              <div class="d-flex">
                <i class="bx bx-chevron-left planner-icon" @click="$refs.calendar.prev()"></i>
                <i class="bx bx-chevron-right planner-icon" @click="$refs.calendar.next()"></i>
                <div style="width: 300px; text-align: start; padding-bottom: 3px;">
                  <span style="color: black; font-size: 25px; padding-bottom: 5px;">{{computedTitle}}</span>
                </div>
              </div>
            </tab>
          </div>

          <div @click="hideDropdown" class="planer-period-menu">
            <div class="dropdown dropdown-options show inline">
              <button type="button"
                      class="btn waves-effect waves-light ex-options-button"
                      id="dropdownMenuLink1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true">
                {{computedType}}
                <span class="dropdown-arrow pull-right" style="box-sizing: border-box; width: 32px; border-left: 1px solid rgba(27,30,56,0.25);">
                    <i class="fa fa-chevron-down pull-right"></i>
                    </span>
              </button>
              <div style="z-index: 9999" class="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="dropdownMenuLink">
                <a class="dropdown-item text-primary p-1 clickable" @click="$store.commit('setPlannerBoardType', 'day')">Day</a>
                <a class="dropdown-item text-primary p-1 clickable" @click="$store.commit('setPlannerBoardType', 'week')">Week</a>
                <a class="dropdown-item text-primary p-1 clickable" @click="$store.commit('setPlannerBoardType', 'month')">Month</a>
              </div>
            </div>
          </div>

          <div class="planer-categories-menu">
            <div class="dropdown dropdown-options show inline">
              <button type="button"
                class="btn waves-effect waves-light ex-categories-button"
                id="dropdownMenuLink3"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
                @click="toggleDropdown">
                Categories
                <span class="dropdown-arrow pull-right" style="box-sizing: border-box; width: 32px; border-left: 1px solid rgba(27,30,56,0.25);">
                    <i class="fa fa-chevron-down pull-right"></i>
                    </span>
              </button>
              <div ref="dropdown" style="z-index: 9999; width: 270px;" class="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="dropdownMenuLink3">
                <span class="text-category-menu">
                  Manage your categories. Create new, name and edit the colour's. To save the changed category name, press enter.
                </span>
                <input @input="filteringCategories" v-model="filterCategoryName" style="margin: 8px 0px 2px 16px; width: 236px" placeholder="Name" type="text" class="form-control"/>
<!--                <h6 style="padding-bottom: 5px; margin: 10px 15px; border-bottom: #e0e0e0 1px solid;">Name</h6>-->



                <a v-for="gr in filteredGroups" :key="gr.id" class="dropdown-item text-primary p-1 clickable d-flex has-child">
                  <span class="categories-menu-color-icon" :style="{backgroundColor: gr.color}"></span>
                  <input placeholder="Name of Category" :ref="'group-' + gr.id" @keypress.enter="updateGroup(gr.id, gr.name, gr.color)" type="text" class="category-input" v-model="gr.name">
                  <div class="dropdown-menu-child">
                    <ul type="none" style="margin-top: 0;">
                      <li>
                        <a @click="addEmptyNewGroup" href="#">Add New</a>
                      </li>
                      <li>
                        <a @click="focusOnCategory(gr.id)" href="#">Rename</a>
                      </li>
                      <li>
                        <a @click="removeGroup(gr.id)" href="#">Delete</a>
                      </li>
                      <li @mouseover="showColorPicker(gr)" @mouseleave="gr.isOpenColorPicker = false; gr.isSetColor = false;">
                        <a  href="#">Colour</a>

                        <div v-if="gr.isOpenColorPicker" class="category-color-picker"  >
                          <div style="position: relative">
                            <v-app>
                              <v-color-picker
                                  dot-size="20"
                                  :canvasHeight="100"
                                  :width="250"
                                  swatches-max-height="200"
                                  v-model="currentColor"
                              ></v-color-picker>
                              <button @click="updateGroup(gr.id, gr.name, currentColor)" class="choose-button">Select</button>
                            </v-app>
                          </div>
                        </div>

                      </li>
                    </ul>
                  </div>
                </a>

<!--                <div class="form-group row planner-categories-btn">-->
<!--                  <button class="btn btn-secondary ml-1" style="width: 100px;">Cancel</button>-->
<!--                  <button class="btn btn-primary" style="width: 100px; color: white;">Save</button>-->
<!--                </div>-->
              </div>
            </div>
          </div>


          <div @click="hideDropdown" class="planer-options-menu">
            <div @click="hideDropdown"  class="dropdown dropdown-options show inline">
              <button type="button"
                class="btn waves-effect waves-light ex-options-button"
                id="dropdownMenuLink2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true">
                Options
                <span class="dropdown-arrow pull-right" style="box-sizing: border-box; width: 32px; border-left: 1px solid rgba(27,30,56,0.25);">
                    <i class="fa fa-chevron-down pull-right"></i>
                    </span>
              </button>
              <div style="z-index: 9999; width: 150px;" class="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="dropdownMenuLink2">
                <a class="dropdown-item text-primary p-1 clickable" @click="$refs.bookingEventModal.show()">Add Vehicle Booking</a>
                <a class="dropdown-item text-primary p-1 clickable" @click="newGeneralEvent.createdBy = userInfo.full_name; $refs.generalEventModal.show()">Add General Event</a>
                <a class="dropdown-item text-primary p-1 clickable" @click="newGeneralEvent.createdBy = userInfo.full_name; newGeneralEvent.isAllDayEvent = true; $refs.generalEventModal.show()">Add All Day Event</a>
              </div>
            </div>
          </div>

        </div>

        <div class="calendar-area" @click="hideDropdown">
          <v-app>
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="computedEvents"
                :event-color="getEventColor"
                :type="getterPlannerBoardType"
                :short-weekdays="false"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
                :event-ripple="false"
                @change="getEvents"
                @mousedown:event="startDrag"
                @mousedown:time="startTime"
                @mousemove:time="mouseMove"
                @mouseup:time="endDrag"
                @mouseleave.native="cancelDrag"
                style="width: 100%; margin: 0 auto; margin-top: 15px !important;">
              <template v-slot:day-body="{ date, week }">
                <div
                  class="v-current-time"
                  :class="{ first: date === 5 }"
                  :style="{ top: nowY }"
                ></div>
              </template>
              <template v-slot:event="{ event, timed, eventSummary }">
                <div :class="{'all-day-event': event.isAllDayEvent}" class="" style="padding-left: 10px">
                  {{event.name}}
                </div>

                <!--              <div-->
                <!--                  class="v-event-draggable"-->
                <!--                  v-html="eventSummary()"-->
                <!--              >{{event}}</div>-->
                <div
                    v-if="timed"
                    class="v-event-drag-bottom"
                    @mousedown.stop="extendBottom(event)"
                ></div>
              </template>
            </v-calendar>
            <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                max-width="300px"
                :nudge-left='200'
            >
              <v-card
                  color="lighten-4"
                  min-width="300px"
                  min-height="280px"
                  flat
              >
                <v-toolbar
                    :color="reactiveSelectedEvent.color"
                    dark
                >
                  <v-toolbar-title v-html="reactiveSelectedEvent.name"></v-toolbar-title>
                  <!--            <v-spacer></v-spacer>-->

                  <v-menu :ref="'eventMenu-' + reactiveSelectedEvent.id" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="planer-btn-menu"
                          text
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="editEvent(reactiveSelectedEvent.id)">
                        <v-list-item-title>Edit Event</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteEvent(reactiveSelectedEvent.id)">
                        <v-list-item-title >Remove Event</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.id" @click="openNewTabCard(reactiveSelectedEvent.card.id)">
                        <v-list-item-title>View Card</v-list-item-title>
                      </v-list-item>
                    </v-list>

                  </v-menu>

                </v-toolbar>
                <v-card-text v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.id" >
                  <div class="calendar-card-details">
                    <span>Rego</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.vehicleRego">{{ reactiveSelectedEvent.card.vehicleRego }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Make</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.vehicleMake">{{ reactiveSelectedEvent.card.vehicleMake }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Model</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.vehicleModel">{{ reactiveSelectedEvent.card.vehicleModel }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Assigned To</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.assignedTo">{{ reactiveSelectedEvent.card.assignedTo }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Insurer</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.insurer">{{ reactiveSelectedEvent.card.insurer }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Parts Arrived (%)</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.partsArrived">{{ reactiveSelectedEvent.card.partsArrived }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Total Hrs</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.totalHrs">{{ reactiveSelectedEvent.card.totalHrs }}</span>
                    <span v-else>-</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Completed (%)</span>
                    <span v-if="reactiveSelectedEvent && reactiveSelectedEvent.card && reactiveSelectedEvent.card.completed">{{ reactiveSelectedEvent.card.completed }}</span>
                    <span v-else>-</span>
                  </div>
                </v-card-text>
                <v-card-text v-else-if="reactiveSelectedEvent" >
                  <div class="calendar-card-details">
                    <span>Date</span>
                    <span>{{getDateTitle(reactiveSelectedEvent.dateStart, reactiveSelectedEvent.dateEnd)}}</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Time Start</span>
                    <span>{{reactiveSelectedEvent.timeStart}}</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Time End</span>
                    <span>{{reactiveSelectedEvent.timeEnd}}</span>
                  </div>
                  <div class="calendar-card-details">
                    <span>Note</span>
                    <span v-if="reactiveSelectedEvent.note">{{reactiveSelectedEvent.note}}</span>
                    <span v-else> - </span>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-app>
        </div>
    </tabs>

    <modal-wizard ref="bookingEventModal" @on-close="closeEditModal" @on-complete="addBookingEvent" :hideFinishButton="true" :hideCancelButton="true">
      <modal-wizard-tab>
        <h4 v-if="isOpenEditVehicleBookingEvent">Edit Vehicle Booking</h4>
        <h4 v-else>Add Vehicle Booking</h4>
        <template>
          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Date In</label>
            <div class="col-sm-8 col-8 p-0">
              <date-picker :options="dpOptions"
                v-model="newBookingEvent.dateStart"
                placeholder="Start">
              </date-picker>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Time</label>
            <div class="col-sm-8 col-8 p-0">
              <vue-timepicker @change="bookingEventTimeChanged"  v-model="newBookingEvent.timeStart" drop-direction="up"/>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Date Out</label>
            <div class="col-sm-8 col-8 p-0">
              <date-picker :options="dpOptions"
                v-model="newBookingEvent.dateEnd"
                placeholder="End">
              </date-picker>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Time</label>
            <div class="col-sm-8 col-8 p-0">
              <vue-timepicker  v-model="newBookingEvent.timeEnd" drop-direction="up"/>
            </div>
          </div>

          <div class="form-group row reminder-multiselect">
            <label class="col-sm-4 col-4 p-0 col-form-label">Reminder</label>
            <div class="col-sm-8 col-8 p-0">
              <multiselect
                  v-model="computedBookingReminder"
                  :options="reminderOptions"
                  :showLabels="false"
                  :option-height="29"
                  :max-height="203"
                  :close-on-select="true"
                  placeholder="Reminder"
                  track-by="key"
                  label="value"
                  @select="opt => newBookingEvent.reminder = opt.key"
                  style="opacity: 1">

              </multiselect>
            </div>
          </div>

          <div class="form-group row reminder-multiselect" style="border-bottom: 1px solid rgba(27, 30, 56, 0.25); height: auto; min-height: 50px">
            <label class="col-sm-4 col-4 p-0 col-form-label">Category</label>
            <div class="col-sm-8 col-8 p-0">
              <multiselect
                  v-model="computedBookingCategory"
                  :options="categoryOptions"
                  :showLabels="false"
                  :option-height="29"
                  :max-height="203"
                  :close-on-select="true"
                  placeholder="Category"
                  track-by="id"
                  label="name"
                  style="opacity: 1">
                <template slot="singleLabel" slot-scope="props">
                  <span style="transform: translateY(3px);" class="categories-menu-color-icon" :style="{backgroundColor: props.option.color}"></span> <span>{{props.option.name}}</span>
                </template>
                <template slot="option" slot-scope="props">
                  <span style="transform: translateY(3px);" class="categories-menu-color-icon" :style="{backgroundColor: props.option.color}"></span> <span>{{props.option.name}}</span>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="form-group row pt-1">
            <label class="col-sm-4 col-4 p-0 col-form-label">Rego</label>
            <div class="col-sm-8 col-8 p-0 adv-search-block">
                <advanced-search
                    v-model="newBookingEvent.vehicleRego"
                    :searchData="searchData"
                    :searchKey="'rego'"
                    :sortByName="'rego'"
                    @onSelect="onRegoSelect"
                    placeholder="Rego">
                </advanced-search>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Make</label>
            <div class="col-sm-8 col-8 p-0">
              <input v-model="newBookingEvent.vehicleMake" id="make" type="text" class="form-control" placeholder="Make" readonly>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Model</label>
            <div class="col-sm-8 col-8 p-0">
              <input v-model="newBookingEvent.vehicleModel" id="model" type="text" class="form-control" placeholder="Model" readonly>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Vehicle Owner</label>
            <div class="col-sm-8 col-8 p-0">
              <input v-model="newBookingEvent.vehicleOwnerName" id="vehicle-owner" type="text" class="form-control" placeholder="Vehicle Owner" readonly>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Card Nbr</label>
            <div class="col-sm-8 col-8 p-0 adv-search-block">
              <advanced-search
                  v-model="newBookingEvent.cardNumber"
                  :searchData="searchData"
                  :searchKey="'cardNumber'"
                  :sortByName="'cardNumber'"
                  @onSelect="onCardNumberSelect"
                  placeholder="Card Nbr">
              </advanced-search>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Notes</label>
            <div class="col-sm-8 col-8 p-0">
              <textarea id="details" v-model="newBookingEvent.note" style="height: 100px !important;" class="form-control" name="" cols="30" rows="10"></textarea>
            </div>
          </div>

          <div class="form-group row" style="padding-bottom: 70px;">
            <label class="col-sm-4 col-4 p-0 col-form-label">Boards</label>
            <div class="col-sm-8 col-8 p-0">
              <multiselect
                v-model="newBookingEvent.boards"
                :options="['Vehicle in Board', 'Departure Board']"
                :max-height="203"
                :multiple="true"
                :selectLabel="''"
                :deselectLabel="'Remove'"
                :searchable="false"
                :selectedLabel="''"
                />
            </div>
          </div>

          <div class="form-group row planner-modal-btn">
            <button @click="$refs.bookingEventModal.hide()" class="btn btn-secondary mr-1" style="width: 100px;">Cancel</button>
            <button @click="onClickSaveBookingEvent" class="btn btn-primary" style="width: 100px; color: white;">Save</button>
          </div>

          <div class="modal-padding-bottom" :style="{height: (modalPaddingBottom - 100) + 'px', }"></div>
        </template>
      </modal-wizard-tab>
    </modal-wizard>

    <modal-wizard ref="generalEventModal" @on-close="closeEditModal" @on-complete="addGeneralEvent" :hideFinishButton="true" :hideCancelButton="true">
      <modal-wizard-tab>
        <h4 v-if="isOpenEditGeneralEvent && newGeneralEvent.isAllDayEvent">Edit All Day Event</h4>
        <h4 v-else-if="isOpenEditGeneralEvent">Edit General Event</h4>
        <h4 v-else-if="newGeneralEvent.isAllDayEvent">Add All Day Event</h4>
        <h4 v-else>Add General Event</h4>
        <template>
          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Title</label>
            <div class="col-sm-8 col-8 p-0">
              <input id="" v-model="newGeneralEvent.title" type="text" class="form-control" placeholder="Title">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Start Date</label>
            <div class="col-sm-8 col-8 p-0">
              <date-picker :options="dpOptions"
                v-model="newGeneralEvent.dateStart"
                placeholder="Start">
              </date-picker>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Time</label>
            <div class="col-sm-8 col-8 p-0">
              <vue-timepicker @change="generalEventTimeChanged" v-model="newGeneralEvent.timeStart" drop-direction="up"/>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">End Date</label>
            <div class="col-sm-8 col-8 p-0">
              <date-picker :options="dpOptions"
                v-model="newGeneralEvent.dateEnd"
                placeholder="End">
              </date-picker>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Time</label>
            <div class="col-sm-8 col-8 p-0">
              <vue-timepicker  v-model="newGeneralEvent.timeEnd" drop-direction="up"/>
            </div>
          </div>

          <div class="form-group row reminder-multiselect">
            <label class="col-sm-4 col-4 p-0 col-form-label">Reminder</label>
            <div class="col-sm-8 col-8 p-0">
              <multiselect
                  v-model="computedGeneralReminder"
                  :options="reminderOptions"
                  :showLabels="false"
                  :option-height="29"
                  :max-height="203"
                  :close-on-select="true"
                  placeholder="Reminder"
                  track-by="key"
                  label="value"
                  @select="opt => newGeneralEvent.reminder = opt.key"
                  style="opacity: 1">

              </multiselect>
            </div>
          </div>

          <div class="form-group row reminder-multiselect" style="border-bottom: 1px solid rgba(27, 30, 56, 0.25); min-height: 50px; height: auto">
            <label class="col-sm-4 col-4 p-0 col-form-label">Category</label>
            <div class="col-sm-8 col-8 p-0">
              <multiselect
                  v-model="computedGeneralCategory"
                  :options="categoryOptions"
                  :showLabels="false"
                  :option-height="29"
                  :max-height="203"
                  :close-on-select="true"
                  placeholder="Category"
                  track-by="id"
                  label="name"
                  style="opacity: 1">
                <template slot="singleLabel" slot-scope="props">
                  <span style="transform: translateY(3px);" class="categories-menu-color-icon" :style="{backgroundColor: props.option.color}"></span> <span>{{props.option.name}}</span>
                </template>
                <template slot="option" slot-scope="props">
                  <span style="transform: translateY(3px);" class="categories-menu-color-icon" :style="{backgroundColor: props.option.color}"></span> <span>{{props.option.name}}</span>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="form-group row pt-1">
            <label class="col-sm-4 col-4 p-0 col-form-label">Location</label>
            <div class="col-sm-8 col-8 p-0">
              <input v-model="newGeneralEvent.location" id="location" type="text" class="form-control" placeholder="Location">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Created By</label>
            <div class="col-sm-8 col-8 p-0">
              <input id="created-by" v-model="newGeneralEvent.createdBy" type="text" class="form-control" placeholder="Name" readonly>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Card Nbr</label>
            <div class="col-sm-8 col-8 p-0 adv-search-block" >
              <advanced-search
                  v-model="newGeneralEvent.cardNumber"
                  :searchData="searchData"
                  :searchKey="'cardNumber'"
                  :sortByName="'cardNumber'"
                  @onSelect="value => newGeneralEvent.cardNumber = value.cardNumber"
                  placeholder="Card Nbr">
              </advanced-search>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-4 p-0 col-form-label">Notes</label>
            <div class="col-sm-8 col-8 p-0">
              <textarea id="details" v-model="newGeneralEvent.note" style="height: 100px !important;" class="form-control" name="" cols="30" rows="10"></textarea>
            </div>
          </div>

          <div class="form-group row planner-modal-btn">
            <button @click="$refs.generalEventModal.hide()" class="btn btn-secondary mr-1" style="width: 100px;">Cancel</button>
            <button @click="onClickSaveGeneralEvent" class="btn btn-primary" style="width: 100px; color: white;">Save</button>
          </div>

          <div class="modal-padding-bottom" :style="{height: modalPaddingBottom + 'px', }"></div>
        </template>
      </modal-wizard-tab>
    </modal-wizard>
  </div>
</template>

<script>
    import DatePicker from '../utility/date-picker';
    import Axios from "axios";
    import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import _ from 'lodash';
    import AdvancedSearch from '../utility/advanced-search';

    export default {
      name: "Planner",
      data() {
        return {
          groups: [],
          filteredGroups: [],
          filterCategoryName: '',
          currentColor: "",
          id: -11,
          isSetTimeByEditMode: false,
          focus: new Date(),
          start: "2000-03-01",
          end: "2070-03-01",
          isShowDropdown: false,
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          shortMonths: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
          colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1', '#2196F3', '#3F51B5', '#673AB7', '#00BCD4', '#4CAF50', '#FF9800', '#757575'],
          selectedOpen: false,
          selectedElement: null,
          value: [],
          selectedEvent: {},
          isOpenEditVehicleBookingEvent: false,
          isOpenEditGeneralEvent: false,
          ready: false,
          events: [
            // {
            //   name: "test1",
            //   start: "2022-03-22 09:00",
            //   end: "2022-03-24 10:00",
            //   color: 'cyan',
            // },
            // {
            //   name: "test2",
            //   start: "2022-03-11",
            //   someInformation: {
            //     cardId: 'c3343'
            //   },
            //   color: 'indigo',
            // },
            // {
            //   name: "test3",
            //   start: "2022-03-05 12:30",
            //   end: "2022-03-05 12:30",
            //   color: 'blue',
            // },
          ],
          newGeneralEvent: {
            "dateStart": "", // required
            "timeStart": "", // required
            "dateEnd": "", // required
            "timeEnd": "", // required
            "title":"", // required
            "note": "", // optional
            "color": "", // optional
            "cardNumber": "", // optional
            reminder: null,
            isAllDayEvent: false,
            location: '',
            createdBy: '',
            category: null,
          },
          newBookingEvent: {
            "cardId": null, // required
            "dateStart": "", // required
            "timeStart": "", // required
            "dateEnd": "", // required
            "timeEnd": "", // required
            "title": "", // optional
            "note": "", // optional
            "color": "", // optional

            boards: [],
            cardNumber: '',
            vehicleMake: '',
            vehicleRego: '',
            vehicleModel: '',
            vehicleOwnerName: '',
            reminder: null,
            category: null,
          },

          reminderOptions: [
            {
              key: 300,
              value: '5 mins'
            },
            {
              key: 600,
              value: '10 mins'
            },
            {
              key: 900,
              value: '15 mins'
            },
            {
              key: 1800,
              value: '30 mins'
            },
            {
              key: 3600,
              value: '1 hour'
            },
            {
              key: 7200,
              value: '2 hours'
            },
            {
              key: 14400,
              value: '4 hours'
            },
            {
              key: 86400,
              value: '1 day'
            },
          ],

          intervalUpdateTitle: null,
          isMounted: false,
          dialog: false,

          dpOptions: {
            autoclose: true,
            todayHighlight: true,
            format: 'yyyy/mm/dd',
          },

          names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
          dragEvent: null,
          dragStart: null,
          createEvent: null,
          createStart: null,
          extendOriginal: null,
          modalPaddingBottom: 0,
        }
      },
      computed: {
        ...mapGetters({
          getterAllCards: 'card/getAllCards',
          userInfo: 'userInfo',
          getterBoardIn: 'board/getBoardIn',
          getterBoardDeparture: 'board/getBoardDeparture',
          getterPlannerBoardType: 'getPlannerBoardType'
        }),
        categoryOptions() {
          let groups = this.groups.slice();
          let emptyCategoryIndex = _.findIndex(this.groups, (gr) => {
            return gr.id === null;
          })
          if (emptyCategoryIndex === -1) {
            groups.unshift({name: 'No Category', id: null, color: '#5f9fa0', isSetColor: false, isOpenColorPicker: false});
          }
          return groups;
        },
        computedBookingCategory: {
          get: function () {
            let vm = this;
            try {
              let item = _.find(this.categoryOptions, (opt) => {
                return opt.id === vm.newBookingEvent.category;
              });
              return item;
            } catch (e) {
              return {}
            }
          },
          set: function (item) {
            // this.newBookingEvent.groupId = item.id;
            this.newBookingEvent.category = item.id;
            console.log('item', item)
          }
        },
        computedGeneralCategory: {
          get: function () {
            let vm = this;
            try {
              let item = _.find(this.categoryOptions, (opt) => {
                return opt.id === vm.newGeneralEvent.category;
              });
              return item;
            } catch (e) {
              return {}
            }
          },
          set: function (item) {
            // this.newGeneralEvent.groupId = item.id;
            this.newGeneralEvent.category = item.id;
            console.log('item', item)
          }
        },
        computedBookingReminder: {
          get: function () {
            let vm = this;
            try {
              let item = _.find(this.reminderOptions, (opt) => {
                return opt.key === vm.newBookingEvent.reminder;
              });
              return item;
            } catch (e) {
              return {}
            }
          },
          set: function (item) {
            console.log('item', item)
          }
        },
        computedGeneralReminder: {
          get: function () {
            let vm = this;
            try {
              let item = _.find(this.reminderOptions, (opt) => {
                return opt.key === vm.newGeneralEvent.reminder;
              });
              return item;
            } catch (e) {
              return {}
            }
          },
          set: function (item) {
            console.log('item', item)
          }
        },
        reactiveSelectedEvent() {
          if (!this.selectedEvent.id) {
            return {
              name: '',
              id: null,
              color: null,
            }
          }
          let item = _.find(this.computedEvents, e => {
            return e.id == this.selectedEvent.id;
          })
          if (item) {
            return item
          }
          return {
            name: '',
            id: null,
            color: null,
          }
        },
        searchData() {
          let result = [];
          _.forEach(this.getterAllCards, (card) => {
            result.push({
              rego: card.rego_number,
              make: card.make,
              model: card.model,
              vehicleOwner: card.customer_name,
              cardNumber: card.card_number,
              cardId: card.card_id,
            })
          });
          return result;
        },
        computedEvents() {
          let events = [];
          _.forEach(this.events, (e) => {
            if (e.color === null || e.groupId === null) {
              e.color =  '#5f9fa0';
            }
            e.name = e.title;

            if ((e.card && e.card.id) || e.isAllDayEvent) {
              e.start = e.dateStart;
              e.end = e.dateEnd;
              e.timed = false;
            } else {
              e.start = this.toTimestamp(e.dateStart + ' ' + e.timeStart);
              e.end = this.toTimestamp(e.dateEnd + ' ' + e.timeEnd);
              e.timed = true;
            }

            events.push(e);
          });
          return events;
        },
        computedTitle() {
          if (this.isMounted) {
            let lastStart = this.$refs.calendar.lastStart;
            let lastEnd = this.$refs.calendar.lastEnd;
            if (this.getterPlannerBoardType === 'month') {
              return this.months[lastStart.month - 1] + ' ' + lastStart.year;
            } else if (this.getterPlannerBoardType === 'week') {
              if (lastStart.year !== lastEnd.year) {
                return lastStart.day + ' ' + this.shortMonths[lastStart.month - 1] + ' ' + lastStart.year +  ' - ' + lastEnd.day + ' ' + this.shortMonths[lastEnd.month - 1] + ' ' + lastEnd.year;
              } else if (lastStart.month !== lastEnd.month) {
                return lastStart.day + ' ' + this.shortMonths[lastStart.month - 1] +  ' - ' + lastEnd.day + ' ' + this.shortMonths[lastEnd.month - 1] + ' ' + lastEnd.year;
              } else {
                return lastStart.day + ' - ' + lastEnd.day + ' ' + this.shortMonths[lastEnd.month - 1] + ' ' + lastEnd.year;
              }
            } else if (this.getterPlannerBoardType === 'day') {
              return lastStart.day + ' ' + this.shortMonths[lastStart.month - 1] + ' ' + lastStart.year;
            }
          }
        },
        computedType() {
          let type = this.getterPlannerBoardType[0].toUpperCase() + this.getterPlannerBoardType.slice(1);
          return type;
        },
        cal () {
          return this.ready ? this.$refs.calendar : null
        },
        nowY () {
          return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
        },
      },
      methods: {
        filteringCategories() {
          let groups = this.groups.slice();
          let self = this;
          let filteredGroups = _.filter(groups, (gr) => {
            if (gr.id <= -10) {
              return true;
            }
            return gr.name.toLowerCase().includes(self.filterCategoryName.toLowerCase());
          });
          this.filteredGroups.splice(0, this.filteredGroups.length);
          _.forEach(filteredGroups, (gr) =>  {
            this.filteredGroups.push(gr);
          })
        },
        toggleDropdown() {
          if (this.isShowDropdown) {
            this.hideDropdown();
          } else {
            this.showDropdown();
          }
        },
        showDropdown() {
          this.isShowDropdown = true;
          $(this.$refs.dropdown).dropdown().toggle(true);
        },
        hideDropdown() {
          this.isShowDropdown = false;
          $(this.$refs.dropdown).dropdown().toggle(false);
        },
        openNewTabCard(cardId) {
          if (this.$refs['eventMenu-' + this.reactiveSelectedEvent.id]) {
            setTimeout(() => {
              this.$refs['eventMenu-' + this.reactiveSelectedEvent.id].isActive = false;
            }, 0)
          }
          setTimeout(() => {
            window.open(
                window.location.origin + "/cards/view/" + cardId,
                "_blank"
            );
          }, 200)
        },
        bookingEventTimeChanged() {
          if (this.isSetTimeByEditMode) {
            this.isSetTimeByEditMode = false;
            return;
          }
          if (!this.newBookingEvent.timeStart.includes('HH') && !this.newBookingEvent.timeStart.includes('mm')) {
            let minsToAdd = 15;
            let time = this.newBookingEvent.timeStart;
            let newTime = new Date(new Date("1970/01/01 " + time).getTime() + minsToAdd * 60000).toLocaleTimeString('en-UK', { hour: '2-digit', minute: '2-digit', hour12: false });
            this.newBookingEvent.timeEnd = newTime;
          }
        },
        generalEventTimeChanged() {
          if (this.isSetTimeByEditMode) {
            this.isSetTimeByEditMode = false;
            return;
          }
          if (!this.newGeneralEvent.timeStart.includes('HH') && !this.newGeneralEvent.timeStart.includes('mm')) {
            let minsToAdd = 15;
            let time = this.newGeneralEvent.timeStart;
            let newTime = new Date(new Date("1970/01/01 " + time).getTime() + minsToAdd * 60000).toLocaleTimeString('en-UK', { hour: '2-digit', minute: '2-digit', hour12: false });
            this.newGeneralEvent.timeEnd = newTime;
          }
        },
        getDateTitle(start, end) {
          if (!start || !end) {
            return '';
          }
          let [yearS, monthS, dayS] = start.split('-');
          let [yearE, monthE, dayE] = end.split('-');
          if (yearS !== yearE) {
            return dayS + ' ' + this.shortMonths[monthS - 1] + ' ' + yearS + ' - ' + dayE + ' ' + this.shortMonths[monthE - 1] + ' ' + yearE;
          } else if (monthE !== monthS) {
            return dayS + ' ' + this.shortMonths[monthS - 1] + ' - ' + dayE + ' ' + this.shortMonths[monthE - 1] + ' ' + yearE;
          } else if (dayS !== dayE) {
            return dayS + ' - ' + dayE + ' ' + this.shortMonths[monthE - 1] + ' ' + yearE;
          } else {
            return dayS + ' ' + this.shortMonths[monthE - 1] + ' ' + yearE;
          }
        },
        onRegoSelect(item) {
          this.newBookingEvent.cardNumber = item.cardNumber;
          this.newBookingEvent.vehicleRego = item.rego;
          this.newBookingEvent.vehicleMake = item.make;
          this.newBookingEvent.vehicleModel = item.model;
          this.newBookingEvent.vehicleOwnerName = item.vehicleOwner;
          this.newBookingEvent.boards = [];
          let vehicleItem = _.find(this.getterBoardIn, (itm) => {
            return Number(itm.cardId) === Number(item.cardId);
          });
          let departureItem = _.find(this.getterBoardDeparture, (itm) => {
            return Number(itm.cardId) === Number(item.cardId);
          })
          if (vehicleItem) {
            this.newBookingEvent.boards.push('Vehicle in Board');
          }
          if (departureItem) {
            this.newBookingEvent.boards.push('Departure Board')
          }
        },
        onCardNumberSelect(item) {
          this.newBookingEvent.cardNumber = item.cardNumber;
          this.newBookingEvent.vehicleRego = item.rego;
          this.newBookingEvent.vehicleMake = item.make;
          this.newBookingEvent.vehicleModel = item.model;
          this.newBookingEvent.vehicleOwnerName = item.vehicleOwner;
          this.newBookingEvent.boards = [];
          let vehicleItem = _.find(this.getterBoardIn, (itm) => {
            return Number(itm.cardId) === Number(item.cardId);
          });
          let departureItem = _.find(this.getterBoardDeparture, (itm) => {
            return Number(itm.cardId) === Number(item.cardId);
          });


          if (vehicleItem) {
            this.newBookingEvent.boards.push('Vehicle in Board');
          }
          if (departureItem) {
            this.newBookingEvent.boards.push('Departure Board')
          }
        },
        findCardId(name) {
          let card = _.find(this.getterAllCards, (card) => {
            return card.card_number.toLowerCase() === name.toLowerCase();
          })
          if (card) {
            return card.card_id;
          }
          return null;
        },
        formatDate(date) {
          let d = new Date(date),
              month = '' + (d.getMonth() + 1),
              day = '' + d.getDate(),
              year = d.getFullYear(),
              hours = '' + d.getHours(),
              minutes = '' + d.getMinutes();

          if (month.length < 2) {
            month = '0' + month;
          }
          if (day.length < 2) {
            day = '0' + day;
          }
          if (hours.length < 2) {
            hours = '0' + hours;
          }

          if (minutes.length < 2) {
            minutes = '0' + minutes
          }

          let date2 = [year, month, day].join('-');
          let time = [hours, minutes].join(':')
          return  [date2, time].join(' ');
        },
        toDate(timestamp) {
          if (typeof(timestamp) !== 'number') {
            return timestamp
          }
          let date = new Date(timestamp);
          return this.formatDate(date);
        },
        toTimestamp(date) {
          if (typeof(date) !== 'string') {
            return date
          }
          // "2022-07-25 09:00"
          if (date.includes(':')) {
            let [date1, date2] = date.split(' ');
            let [year, month, day] = date1.split('-');
            let [hours, minutes] = date2.split(':');

            let datum = new Date(year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':00');
            return datum.getTime();

          } else {
            let [year, month, day] = date.split('-');
            let datum = new Date(year + '-' + month + '-' + day + 'T00:00:00');
            return datum.getTime();
          }
        },
        startDrag ({ event, timed }) {
          if (event && timed) {
            this.dragEvent = event
            this.dragTime = null
            this.extendOriginal = null
          }
        },
        startTime (tms) {
          const mouse = this.toTime(tms)

          if (this.dragEvent && this.dragTime === null) {
            let start = this.toTimestamp(this.dragEvent.start);

            this.dragTime = mouse - start
          }
        },
        extendBottom (event) {
          this.createEvent = event
          this.createStart = this.toTimestamp(event.start)
          this.extendOriginal = this.toTimestamp(event.end)
        },
        mouseMove (tms) {
          const mouse = this.toTime(tms)

          if (this.dragEvent && this.dragTime !== null) {
            const start = this.toTimestamp(this.dragEvent.start)
            const end = this.toTimestamp(this.dragEvent.end)
            const duration = end - start
            const newStartTime = mouse - this.dragTime
            const newStart = this.roundTime(newStartTime)
            const newEnd = newStart + duration

            this.dragEvent.start = newStart;
            this.dragEvent.end = newEnd;
          } else if (this.createEvent && this.createStart !== null) {
            const mouseRounded = this.roundTime(mouse, false)
            const min = Math.min(mouseRounded, this.createStart)
            const max = Math.max(mouseRounded, this.createStart)

            this.createEvent.start = min
            this.createEvent.end = max
          }
        },
        endDrag () {
          if (this.dragEvent && this.dragEvent.id) {
            this.updateEvent(this.dragEvent)
          }
          if (this.createEvent && this.createEvent.id) {
            this.updateEvent(this.createEvent);
          }
          this.dragTime = null
          this.dragEvent = null
          this.createEvent = null
          this.createStart = null
          this.extendOriginal = null
        },
        cancelDrag () {
          if (this.createEvent) {
            if (this.extendOriginal) {
              this.createEvent.end = this.extendOriginal
            } else {
              const i = this.events.indexOf(this.createEvent)
              if (i !== -1) {
                this.events.splice(i, 1)
              }
            }
          }

          this.createEvent = null
          this.createStart = null
          this.dragTime = null
          this.dragEvent = null
        },
        roundTime (time, down = true) {
          const roundTo = 15 // minutes
          const roundDownTime = roundTo * 60 * 1000

          return down
              ? time - time % roundDownTime
              : time + (roundDownTime - (time % roundDownTime))
        },
        toTime (tms) {
          return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
        },
        getEvents () {
          return
          const events = []
          let self = this;
          _.forEach(this.events, (e) =>  {
            let start = '';
            let end = '';
            if (this.getterPlannerBoardType !== 'month') {
              start = self.toTimestamp(e.dateStart + ' ' +  e.timeStart.slice(0, 5));
              end = self.toTimestamp(e.dateEnd + ' ' +  e.timeEnd.slice(0, 5));
            } else {
              start = e.dateStart + ' ' +  e.timeStart.slice(0, 5);
              end = e.dateEnd + ' ' +  e.timeEnd.slice(0, 5);
            }

            let event = {
              name: e.name,
              color: e.color,
              id: e.id,
              timed: true,
              category: e.groupId,
              ...e
            };
            // event.start = '';
            // event.end = end;
            // events.push(event);
          })
          this.events.splice(0, this.events.length);
          _.forEach(events, e => {
            this.events.push(e);
          })
         // this.events = events
        },
        rnd (a, b) {
          return Math.floor((b - a + 1) * Math.random()) + a
        },
        rndElement (arr) {
          return arr[this.rnd(0, arr.length - 1)]
        },
        getRandomNumber(min, max) {
          let rand = min - 0.5 + Math.random() * (max - min + 1);
          return Math.round(rand);
        },
        loadCategories() {
          Axios.get('/fe/planner-board/groups')
              .then(response => {
                if (response.data.groups && response.data._status) {
                  this.groups.splice(0, this.groups.length);
                  _.forEach(response.data.groups, (gr) => {
                    this.groups.push({
                      isOpenColorPicker: false,
                      isSetColor: false,
                      ...gr,
                    });
                  });
                  this.filteringCategories();
                }
              })
              .finally(()=> {})
        },
        focusOnCategory(id) {
          setTimeout(() => {
            this.$refs['group-' + id][0].focus();
          })
        },
        addEmptyNewGroup() {
          let id = this.id--;
          this.groups.push({
            name: '',
            color: '',
            id: id,
            isOpenColorPicker: false,
            isSetColor: false,
          });
          this.filteringCategories();
          setTimeout(() => {
            this.$refs['group-' + id][0].focus();
          })
        },
        removeEmptyNewGroup(id) {
          let index = _.findIndex(this.groups, (gr) => {
            return Number(gr.id) === Number(id);
          });
          if (index !== -1) {
            this.groups.splice(index, 1);
          };
          this.filteringCategories();
        },
        addNewGroup(name, color, newEventId = null) {
          if (!color) {
            toastr.error('Color is required')
          }
          if (!name) {
            toastr.error('Name is required')
          }
          Axios.post('/fe/planner-board/group/add', {
            name: name,
            color: color,
          })
              .then((response) => {
                if (response.data && response.data._status && response.data.group) {
                  toastr.success('Added new category');
                  if (newEventId) {
                    let index = _.findIndex(this.groups, (gr) => {
                      return Number(gr.id) === Number(newEventId);
                    });
                    if (index !== -1) {
                      this.groups.splice(index, 1);
                    }
                  }
                  this.groups.push({
                    ...response.data.group,
                    isOpenColorPicker: false,
                    isSetColor: false,
                  });
                  this.filteringCategories();
                }
              })
        },
        updateGroup(id, name, color) {
          if (id <= -10) {
            this.addNewGroup(name, color, id);
            return;
          }
          Axios.post('/fe/planner-board/group/update', {
            name: name,
            color: color,
            id: id,
          })
              .then((response) => {
                if (response.data && response.data._status && response.data.group) {
                  toastr.success('Updated category');
                  let updatedGroup = _.find(this.groups, (gr) => {
                    return Number(gr.id) === Number(id);
                  })
                  if (updatedGroup) {
                    updatedGroup.name = response.data.group.name;
                    updatedGroup.color = response.data.group.color;
                  }
                  this.filteringCategories();
                }
              })
        },
        showColorPicker(gr) {
          gr.isOpenColorPicker = true;
          if (!gr.isSetColor) {
            gr.isSetColor = true;
            this.currentColor = gr.color;
          }
        },
        removeGroup(id) {
          if (id <= -10) {
            this.removeEmptyNewGroup(id);
            return;
          }
          Axios.post('/fe/planner-board/group/remove', {
            id: id,
          })
              .then((response) => {
                if (response.data && response.data._status) {
                  toastr.error('Removed category')
                  let index = _.findIndex(this.groups, (gr) => {
                    return Number(gr.id) === Number(id);
                  });
                  if (index !== -1) {
                    this.groups.splice(index, 1);
                  };
                  this.filteringCategories();
                }
              })
        },
        loadEvents(isShowNProgress = false) {
          // this.events = [
          //   {
          //     color: 'green',
          //     start: "2022-07-25 09:00",
          //     name: 'test event',
          //     end: "2022-07-26 10:00",
          //     timed: true,
          //   }
          // ]
          if (isShowNProgress) {
            NProgress.start()
          };
          Axios.get('/fe/planner-board')
              .then(response => {
                if (!response.data.data) {
                  return;
                }
                this.events.splice(0, this.events.length);
                let vm = this;
                _.forEach(response.data.data, function (item) {
                  let newEvent = {
                    name: item.title,
                    color: item.color,
                    start: item.timeStart !== null ? item.dateStart + ' ' + item.timeStart.slice(0, 5) : item.dateStart,
                    end: item.timeEnd !== null ? item.dateEnd + ' ' + item.timeEnd.slice(0, 5) : item.dateEnd,
                    timed: true,
                    category: item.groupId,
                    ...item
                  }
                  vm.events.push(newEvent)
                })
              })
              .finally(()=> {
                if (isShowNProgress) {
                  NProgress.done();
                }
              })
        },
        convertTime(time) {
          let newTime = time.split(':');
          if (newTime.length === 2) {
            return time + ':00'
          }
          return time;
        },
        convertDate(date) {
          date = date.replaceAll('/', '-')
          let [day, month, year] = date.split('-');
          if (day.length === 4) {
            return date;
          }
          return [year, month, day].join('-');
        },
        addGeneralEvent() {
          if (!this.newGeneralEvent.dateStart) {
            toastr.error('Field "Date In" must not be empty');
            return;
          } else if (!this.newGeneralEvent.timeStart) {
            toastr.error('Field "Time Start" must not be empty');
            return;
          } else if (!this.newGeneralEvent.dateEnd) {
            toastr.error('Field "Date Out" must not be empty');
            return;
          } else if (!this.newGeneralEvent.timeEnd) {
            toastr.error('Field "Time End" must not be empty');
            return;
          } else if (!this.newGeneralEvent.title) {
            toastr.error('Field "Title" must not be empty');
            return;
          }
          let selectedCategory = _.find(this.categoryOptions, (c) => {
            return c.id == this.newGeneralEvent.category;
          })
          NProgress.start();
          let data = {
            "dateStart": this.convertDate(this.newGeneralEvent.dateStart) , // required
            "timeStart": this.newGeneralEvent.timeStart + ':00', // required
            "dateEnd":  this.convertDate(this.newGeneralEvent.dateEnd), // required
            "timeEnd": this.newGeneralEvent.timeEnd + ':00', // required
            "title": this.newGeneralEvent.title, // required
            "note": this.newGeneralEvent.note, // optional
            "color": selectedCategory.color, // optional
            "cardNumber": this.newGeneralEvent.cardNumber, // optional
            reminder: +this.newGeneralEvent.reminder,
            location: this.newGeneralEvent.location,
            isAllDayEvent: this.newGeneralEvent.isAllDayEvent,
            groupId: this.newGeneralEvent.category,
          }
          Axios.post('/fe/planner-board/add', data)
              .then((response) => {
                this.loadEvents();
              })
              .finally(() => {
                 this.newGeneralEvent = {
                   "dateStart": "", // required
                   "timeStart": "", // required
                   "dateEnd": "", // required
                   "timeEnd": "", // required
                   "title":"", // required
                   "note": "", // optional
                   "color": "", // optional
                   "cardNumber": "", // optional
                   isAllDayEvent: false,
                   location: '',
                   category: null,
                   createdBy: this.userInfo.full_name,
                   reminder: null
                };
                this.$refs.generalEventModal.hide();
                NProgress.done();
              });

        },
        onClickSaveGeneralEvent() {
          if (this.isOpenEditGeneralEvent) {
            this.updateGeneralEvent();
          } else {
            this.addGeneralEvent();
          }
        },
        onClickSaveBookingEvent() {
          if (this.isOpenEditVehicleBookingEvent) {
            this.updateBookingEvent();
          } else {
            this.addBookingEvent();
          }
        },
        updateGeneralEvent() {
          let selectedCategory = _.find(this.categoryOptions, (c) => {
            return c.id == this.newGeneralEvent.category;
          })
          Axios.post(
              "/fe/planner-board/update",
              {
                "id": this.selectedEvent.id,
                "dateStart": this.convertDate(this.newGeneralEvent.dateStart),
                "timeStart": this.convertTime(this.newGeneralEvent.timeStart),
                "dateEnd": this.convertDate(this.newGeneralEvent.dateEnd),
                "timeEnd": this.convertTime(this.newGeneralEvent.timeEnd),
                "title": this.newGeneralEvent.title,
                "note": this.newGeneralEvent.note,
                "color": selectedCategory.color,
                "cardNumber": this.newGeneralEvent.cardNumber,
                reminder: +this.newGeneralEvent.reminder,
                location: this.newGeneralEvent.location,
                groupId: this.newGeneralEvent.category,
              }
          ).then(response => {
            if (response.data && response.data._status) {
              this.loadEvents();
              toastr.success('Updated!');
            }
          })
              .finally(() => {
                this.$refs.generalEventModal.hide();
              })
        },
        updateBookingEvent() {
          let dataForBoard = [];
          let dataForRemovedBoards = [];

          if (this.newBookingEvent.boards.includes('Vehicle in Board')) {
            dataForBoard.push('in');
          }
          if (this.newBookingEvent.boards.includes('Departure Board')) {
            dataForBoard.push('departure');
          }
          if (this.selectedEvent.card && this.selectedEvent.card.boardIn && this.selectedEvent.card.boardIn.id && !dataForBoard.includes('in')) {
            dataForRemovedBoards.push(this.selectedEvent.card.boardIn.id);
          }
          if (this.selectedEvent.card && this.selectedEvent.card.boardDeparture && this.selectedEvent.card.boardDeparture.id && !dataForBoard.includes('departure')) {
            dataForRemovedBoards.push(this.selectedEvent.card.boardDeparture.id);
          }

          let selectedCategory = _.find(this.categoryOptions, (c) => {
            return c.id == this.newBookingEvent.category;
          })

          Axios.post(
              "/fe/planner-board/update",
              {
                "id": this.selectedEvent.id,
                "dateStart": this.convertDate(this.newBookingEvent.dateStart),
                "timeStart": this.convertTime(this.newBookingEvent.timeStart),
                "dateEnd": this.convertDate(this.newBookingEvent.dateEnd),
                "timeEnd": this.convertTime(this.newBookingEvent.timeEnd),
                "title": this.newBookingEvent.title,
                "note": this.newBookingEvent.note,
                "color": selectedCategory.color,
                "cardNumber": this.newBookingEvent.cardNumber,
                reminder: this.newBookingEvent.reminder,
                addToBoard: dataForBoard,
                removeFromBoard: dataForRemovedBoards,
                groupId: this.newBookingEvent.category,
              }
          ).then(response => {
            if (response.data && response.data._status) {
              this.loadEvents();
              toastr.success('Updated!');
            }
          })
          .finally(() => {
            this.$refs.bookingEventModal.hide();
          })
        },
        addBookingEvent() {
          if (!this.newBookingEvent.dateStart) {
            toastr.error('Field "Date In" must not be empty');
            return;
          } else if (!this.newBookingEvent.timeStart) {
            toastr.error('Field "Time Start" must not be empty');
            return;
          } else if (!this.newBookingEvent.dateEnd) {
            toastr.error('Field "Date Out" must not be empty');
            return;
          } else if (!this.newBookingEvent.timeEnd) {
            toastr.error('Field "Time End" must not be empty');
            return;
          } else if (!this.newBookingEvent.cardNumber) {
            toastr.error('Field "Card Number" must not be empty');
            return;
          }

          let title = '';
          if (this.newBookingEvent.vehicleRego) {
            title += this.newBookingEvent.vehicleRego + ' - '
          }
          if (this.newBookingEvent.cardNumber) {
            title += this.newBookingEvent.cardNumber + ' ';
          }
          if (this.newBookingEvent.vehicleMake) {
            title += this.newBookingEvent.vehicleMake + ' ';
          }
          if (this.newBookingEvent.vehicleModel) {
            title += this.newBookingEvent.vehicleModel;
          }

          let dataForBoard = [];
          if (this.newBookingEvent.boards.includes('Vehicle in Board')) {
            dataForBoard.push('in');
          }
          if (this.newBookingEvent.boards.includes('Departure Board')) {
            dataForBoard.push('departure');
          }
          let selectedCategory = _.find(this.categoryOptions, (c) => {
            return c.id == this.newBookingEvent.category;
          })
          // NProgress.start();
          let data = {
            "cardId": this.findCardId(this.newBookingEvent.cardNumber), // required
            "dateStart": this.convertDate(this.newBookingEvent.dateStart) , // required
            "timeStart": this.newBookingEvent.timeStart + ':00', // required
            "dateEnd":  this.convertDate(this.newBookingEvent.dateEnd), // required
            "timeEnd": this.newBookingEvent.timeEnd + ':00', // required
            "title": title, // optional
            "note": this.newBookingEvent.note, // optional
            "color": selectedCategory.color, // optional
            reminder: +this.newBookingEvent.reminder,
            'addToBoard': dataForBoard,
            groupId: this.newBookingEvent.category,
          }
          Axios.post('/fe/planner-board/add', data)
              .then((response) => {
                this.loadEvents();
              })
              .finally(() => {
                 this.newBookingEvent = {
                   "cardId": null,
                   "dateStart": "",
                   "timeStart": "",
                   "dateEnd": "",
                   "timeEnd": "",
                   "title": "",
                   "note": "",
                   "color": "",
                   category: null,

                   boards: [],
                   cardNumber: '',
                   vehicleMake: '',
                   vehicleRego: '',
                   vehicleModel: '',
                   vehicleOwnerName: '',
                   reminder: null,
                 };
                this.$refs.bookingEventModal.hide();
                NProgress.done();
              });
        },
        updateEvent(event) {
          Axios.post(
              "/fe/planner-board/update",
              {
                id: event.id,
                dateStart: this.toDate(event.start),
                dateEnd: this.toDate(event.end),
              }
          ).then(response => {
            this.loadEvents();
          })
        },
        deleteEvent(id) {
          NProgress.start();
          Axios.post(
              "/fe/planner-board/delete",
              {
                id: id,
              }
          ).then(response => {
            let event = _.find(this.events, function (item) {
              return item.id == id
            })
            let index = this.events.indexOf(event)
            this.events.splice(index, 1)
            toastr.error("Event deleted");
          })
          .finally(()=> {
            NProgress.done();
          })
        },
        editEvent(id) {
          this.selectedEvent = _.find(this.computedEvents, (e) => {
            return e.id == id
          })
          this.isSetTimeByEditMode = true;
          this.isOpenEditVehicleBookingEvent = true;
          this.isOpenEditGeneralEvent = true;
          if (this.selectedEvent.card && this.selectedEvent.card.id) {
            this.newBookingEvent = {
              "cardId": this.selectedEvent.card.id,
              "dateStart": this.selectedEvent.dateStart,
              "timeStart": this.selectedEvent.timeStart,
              "dateEnd": this.selectedEvent.dateEnd,
              "timeEnd": this.selectedEvent.timeEnd,
              "title": this.selectedEvent.title,
              "note": this.selectedEvent.note,
              "color": this.selectedEvent.color,
              boards: [],
              category: this.selectedEvent.groupId,

              cardNumber: this.selectedEvent.card.number,
              vehicleMake: this.selectedEvent.card.vehicleMake,
              vehicleRego: this.selectedEvent.card.vehicleRego,
              vehicleModel: this.selectedEvent.card.vehicleModel,
              vehicleOwnerName: this.selectedEvent.card.vehicleOwner,
              reminder: +this.selectedEvent.reminder,
            };
            if (this.selectedEvent && this.selectedEvent.card && this.selectedEvent.card.boardIn && this.selectedEvent.card.boardIn.id) {
              this.newBookingEvent.boards.push('Vehicle in Board');
            }
            if (this.selectedEvent && this.selectedEvent.card && this.selectedEvent.card.boardDeparture && this.selectedEvent.card.boardDeparture.id) {
              this.newBookingEvent.boards.push('Departure Board');
            }
            this.$refs.bookingEventModal.show()
          } else {
            this.newGeneralEvent = {
              category: this.selectedEvent.groupId,
              "dateStart": this.selectedEvent.dateStart, // required
              "timeStart": this.selectedEvent.timeStart, // required
              "dateEnd": this.selectedEvent.dateEnd, // required
              "timeEnd": this.selectedEvent.timeEnd, // required
              "title": this.selectedEvent.title, // required
              "note": this.selectedEvent.note, // optional
              "color": this.selectedEvent.color, // optional
              "cardNumber": this.selectedEvent.cardNumber, // optional
              reminder: +this.selectedEvent.reminder,
              isAllDayEvent: this.selectedEvent.isAllDayEvent,

              location: this.selectedEvent.location,
              // createdBy: this.selectedEvent.createdBy,
              createdBy: this.userInfo.full_name,
            };
            this.$refs.generalEventModal.show();
          }
        },
        closeEditModal() {
          this.isOpenEditGeneralEvent = false;
          this.isOpenEditVehicleBookingEvent = false;
          this.newBookingEvent = {
            "cardId": null,
            "dateStart": "",
            "timeStart": "",
            "dateEnd": "",
            "timeEnd": "",
            "title": "",
            "note": "",
            "color": "",
            category: null,
            boards: [],
            cardNumber: '',
            vehicleMake: '',
            vehicleRego: '',
            vehicleModel: '',
            vehicleOwnerName: '',
            reminder: null,
          };
          this.newGeneralEvent = {
            "dateStart": "", // required
            "timeStart": "", // required
            "dateEnd": "", // required
            "timeEnd": "", // required
            "title":"", // required
            "note": "", // optional
            "color": "", // optional
            "cardNumber": "", // optional
            category: null,
            location: '',
            isAllDayEvent: false,
            createdBy: '',
            reminder: null,
          };
        },
        showEvent ({ nativeEvent, event }) {
          console.log('event', event)
          const open = () => {
            this.selectedEvent = event;
            this.selectedElement = nativeEvent.target
            requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            console.log(window.innerWidth)
          }

          if (this.selectedOpen) {
            this.selectedOpen = false
            requestAnimationFrame(() => requestAnimationFrame(() => open()))
          } else {
            open()
          }

          nativeEvent.stopPropagation()
        },
        getEventColor (event) {
          return event.color
        },
        viewDay ({ date }) {
          this.focus = date
          this.$store.commit("setPlannerBoardType", 'day');
        },
        setCompactSidebar() {
          this.$nextTick(() => {
            document.body.classList.add('compact-sidebar');
          });
        },
        getCurrentTime () {
          return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
        },
        scrollToTime () {
          const time = this.getCurrentTime()
          const first = Math.max(0, time - (time % 30) - 30)
          if (this.cal.times.now.hour < 6) {
            this.cal.scrollToTime(320)
          } else {
            this.cal.scrollToTime(first)
          }
        },
        updateTime () {
          setInterval(() => this.cal.updateTimes(), 60 * 1000)
        },
      },
      mounted() {
        this.loadCategories();
        this.setCompactSidebar();
        this.isMounted = true;
        this.loadEvents(true);
        this.modalPaddingBottom = window.innerHeight - 1200;
        document.querySelector('.site-header').addEventListener('click', this.hideDropdown);
        document.querySelector('.site-sidebar').addEventListener('click', this.hideDropdown);
        this.ready = true
        this.scrollToTime()
        this.updateTime()
      },
      unmounted() {
        document.querySelector('.site-header').removeEventListener('click', this.hideDropdown);
        document.querySelector('.site-sidebar').removeEventListener('click', this.hideDropdown);
      },
      components: {
        DatePicker,
        VueTimepicker,
        Multiselect,
        AdvancedSearch,
      },
      beforeDestroy() {
        clearInterval(this.intervalUpdateTitle);
      },
      beforeRouteLeave(to, from, next) {
        document.body.classList.remove('compact-sidebar');
        next();
      },
    }
</script>

<style scoped lang="scss">
  .v-event-draggable {
    padding-left: 6px;
  }

  .v-event-timed {
    user-select: none;
    -webkit-user-select: none;
  }

  .v-event-drag-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4px;
    height: 4px;
    cursor: ns-resize;

    &::after {
      display: none;
      position: absolute;
      left: 50%;
      height: 4px;
      border-top: 1px solid white;
      border-bottom: 1px solid white;
      width: 16px;
      margin-left: -8px;
      opacity: 0.8;
      content: '';
    }

    &:hover::after {
      display: block;
    }
  }

  .bx-menu {
    font-size: 30px;
  }

  .planer-btn-menu {
    height: 28px !important;
    min-width: 30px !important;
    width: 30px !important;
  }

  .calendar-card-details {
    display: flex;
  }

  .calendar-card-details span {
    display: block;
    width: 50%;
    margin-bottom: 5px;
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
  }
  .add-booking-event-menu {
    padding: 0;
    position: absolute;
    left: 0;
    right: 0;
  }

  .planer-date-period {
    width: 100%;
    padding-left: 300px;
  }

  .planer-period-menu {
    padding-right: 135px;
  }

  .planer-categories-menu {
    margin-right: 0;
    width: 150px;
  }

  .planer-options-menu {
    padding-left: 150px;
  }

  .planner-categories-btn {
    justify-content: space-around;
    padding: 50px 5px 20px 5px;
  }

  .planner-categories-btn .btn {
    padding: 10px 0px;
    text-align: center;
  }

  .planner-categories-btn .btn-primary {
    background-color: #5E79FF;
  }
</style>
<style>
  .Vue-Toastification__container {
    z-index: 999999999;
  }
  .planner-page .all-day-event {
    text-align: center;
  }
  .planner-page .choose-button {
    background-color: #5E79FF;
    color: white;
    font-size: 13px;
    font-weight: bold;
    border-radius: 3px;
    cursor: pointer;
    padding: 0.75rem 1rem;
    margin-top: 10px;
    margin-left: 160px;
    width: 80px;
    position: absolute;
    top: 265px;
  }
  .planner-page .category-input {
    cursor: pointer;
  }
  .planner-page .category-color-picker {
    position: absolute;
    right: -253px;
    top: -4px;
  }
  .planner-page .adv-search-block .text-grey {
    right: 1rem !important;
  }
  .planner-page .header {
    z-index: 99;
    display: flex;
    padding-top: 20px !important;
    width: 99% !important;
    overflow: inherit;
    justify-content: flex-end;
  }
  .planner-page .planner-icon {
    font-size: 35px;
    color: black;
  }
  .planner-page .planner-icon:hover {
    cursor: pointer;
  }

  .planner-page .v-toolbar__content {
    justify-content: space-between;
  }

  @media (min-width: 992px) {
    .planner-page .modal-lg {
      max-width: 500px !important;
    }
  }

  .planner-page .planner-modal-btn {
    justify-content: end;
    padding-top: 20px;
    position: sticky;
    bottom: 0;
    background-color: #fff;
  }

  .modal-wizard .modal-footer {
    background-color: #fff;
  }

  .planner-page .calendar-area .v-application--wrap {
    height: 75vh;
    padding-left: 15px;
    padding-right: 15px;
    min-height: auto;
  }

  .planner-page .category-color-picker {
    display: block;
  }

  .planner-page .category-color-picker .v-application {
    /*height: 256px;*/
    max-height: 330px;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgb(27 30 56 / 15%);
    border: 1px solid rgba(0,0,0,.15);
  }

  .planner-page .nav-tabs.nav-tabs-2 {
    position: absolute;
    top: 45px;
  }

  .planner-page .modal {
    right: -350px;
    z-index: 999999;
  }

  .planner-page .modal,
  .planner-page .modal-wizard {
    top: 0 !important;
    left: 0 !important;
  }

  .planner-page .modal-dialog {
    right: 0;
    position: absolute;
    width: 330px;
    margin: 0;
  }

  @media screen and (max-height: 1160px) {
    .planner-page .modal-wizard .modal-footer {
      display: none;
    }
    .planner-page .planner-modal-btn {
      border-top: 1px solid rgba(27, 30, 56, 0.25);
      padding-bottom: 31px !important;
    }
    .planner-page .modal-content {
      height: 100%;
    }
  }

  @media screen and (min-height: 920px) and (max-height: 1159px) {
    .planner-page .modal-dialog {
      height: 100% !important;
    }
  }

  @media screen and (min-height: 1160px) {
    .planner-page .modal-dialog {
      height: 900px;
      bottom: 0;
    }
    .planner-page .modal-content {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .planner-page .planner-modal-btn {
      padding-top: 70px;
    }
  }

  .planner-page .fade.in {
    transform: translateX(-350px);
  }

  .planner-page .modal.fade .modal-dialog {
    right: 0;
  }

  .planner-page .modal-backdrop.in {
    opacity: 0 !important;
  }

  .planner-page .modal .form-group {
    margin: 0 !important;
    align-items: center;
    padding-bottom: 10px;
  }

  .planner-page .modal .multiselect__content-wrapper {
    height: 72px;
  }

  .planner-page .modal .reminder-multiselect .multiselect__content-wrapper {
    height: 150px;
  }

  .planner-page .modal .multiselect__tags {
    min-height: 32px !important;
  }

  .multiselect__option:after {
    line-height: 29px;
    padding-right: 5px;
    padding-left: 0px;
  }

  .V3 .planner-page .tabs-component {
    position: relative;
    top: 0;
  }

  .V3 .planner-page .tab-content-table {
    border-top: none;
  }

  .V3 .planner-page .form-control {
    padding: 0.5rem 0.75rem;
  }

  .text-category-menu {
    display: block;
    padding: 5px 10px 5px 15px !important;
    background-color: #80808038;
    font-size: 10px;
    font-weight: 700;
  }

  .V3 .planner-page .v-application {
    margin-top: 3px !important;
  }

  .categories-menu-color-icon {
    display: inline-block;
    height: 15px;
    width: 15px;
    border-radius: 3px;
    margin-right: 10px !important;
  }

  .V3 .planner-page .dropdown-menu-child {
    border-radius: 3px;
    right: -50px;
    min-width: 100px;
    padding-top: 0 !important;
  }

  .V3 .planner-page .dropdown-menu-child li a {
    padding: 10px 18px;
  }

  .V3 .planner-page .v-current-time {
    height: 2px;
    background-color: #7267E7;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;
  }

  .V3 .planner-page .v-current-time .first::before {
    content: '';
    position: absolute;
    background-color: #7267E7;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
</style>

<style scoped src="vuetify/dist/vuetify.min.css"></style>

